import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Alert, Box, Chip, Paper, Snackbar, Stack, Typography } from "@mui/material";

// «معلميّ» in the student profile — read only: the teacher decides who is in
// their class, the student just sees where they belong.
const STATUS = {
  approved: { label: "مُسجَّل", color: "success" },
  pending: { label: "قيد الإضافة", color: "warning" },
  rejected: { label: "غير مُسجَّل", color: "default" },
};

const API = process.env.REACT_APP_API_URL;

const MyTeachersSection = () => {
  const [links, setLinks] = useState(null);
  const [toast, setToast] = useState(null);

  const load = useCallback(() => {
    axios
      .get(`${API}/my-teachers`)
      .then((response) => setLinks(response?.data?.data ?? []))
      .catch(() => setLinks([]));
  }, []);

  useEffect(load, [load]);

  if (!links) return null;

  return (
    <Paper
      elevation={2}
      sx={{ borderRadius: "20px", padding: "25px", width: "min(700px, 100%)", marginTop: "20px" }}
    >
      <Typography variant="h6" mb={2}>👨‍🏫 معلميّ</Typography>

      {links.length === 0 ? (
        <Typography fontSize="0.88rem" color="text.secondary">
          لست مشتركاً مع أي معلم بعد — معلمك هو من يضيفك إلى صفه.
        </Typography>
      ) : (
        <Stack sx={{ gap: 1 }}>
          {links.map((link) => {
            const state = STATUS[link.status] || STATUS.pending;

            return (
              <Box key={link.id} sx={{
                display: "flex", alignItems: "center", gap: 1.2, flexWrap: "wrap",
                padding: "12px 14px", borderRadius: "12px", background: "#F8F8FA",
              }}>
                <Box sx={{ flex: 1, minWidth: 160 }}>
                  <Typography fontWeight={700}>{link.teacher}</Typography>
                  <Typography fontSize="0.76rem" color="text.secondary">
                    {[link.subject, link.class, link.school].filter(Boolean).join(" · ")}
                  </Typography>
                </Box>

                <Chip size="small" color={state.color} label={state.label} sx={{ fontWeight: 700 }} />
              </Box>
            );
          })}
        </Stack>
      )}

      <Snackbar open={Boolean(toast)} autoHideDuration={4000} onClose={() => setToast(null)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert severity={toast?.severity || "info"} onClose={() => setToast(null)}>
          {toast?.text}
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default MyTeachersSection;
